import React, {useCallback} from 'react'
import {ReactSVG} from 'react-svg'
import utils from '@eitje/utils'
import {iconMap} from '@eitje/assets'
import './styles.less'

// IMPORTANT

// The <svg> tags of icons should have the following attribute for the icon to show:
// xmlns="http://www.w3.org/2000/svg"

// Prevents focus from shifting to the SVG icon when clicked inside a focused input.
// This allows the onClick to respond immediately without requiring a second click.

const handleMouseDown = e => e.preventDefault()

export const Icon = ({
	name,
	initialFill,
	fill = initialFill,
	stroke,
	type,
	iconLibrary = 'flaticon',
	size = 16,
	className,
	rotatingAnimation,
	style,
	...rest
}) => {
	const sizeWithUnit = typeof size === 'number' ? `${size}px` : size

	const onBeforeInjection = useCallback(
		svg => {
			const paths = svg.querySelectorAll('path,line,g')
			svg.setAttribute('width', sizeWithUnit)
			svg.setAttribute('height', sizeWithUnit)
			const shouldColor = svg.getAttribute('dontColor') !== 'true'
			if (shouldColor) {
				paths?.forEach(path => path.setAttribute('style', `fill: ${fill}; stroke: ${stroke}`))
			}
			if (rest.onClick) {
				svg.style.cursor = 'pointer'
			}
		},
		[rest.onClick, fill, sizeWithUnit, stroke],
	)

	if (!name) return null

	const variants = [type, 'regular'].filter(Boolean)
	const key = variants.map(v => `${iconLibrary}/${v}/${name}`).find(k => iconMap[k])

	if (!key) return null

	const classNames = utils.makeCns(
		utils.makeCnVariants('eitje-icon', !rest.onClick && 'no-pointer'),
		className,
		utils.makeCnVariants('react-svg-wrapper', initialFill && 'initial-fill'),
		rotatingAnimation && 'rotating-animation',
	)

	const wrapperStyle = {
		width: sizeWithUnit,
		height: sizeWithUnit,
		display: 'inline-block',
		...style,
	}

	return (
		<ReactSVG
			className={classNames}
			beforeInjection={onBeforeInjection}
			src={iconMap[key]}
			wrapper="span"
			onMouseDown={handleMouseDown}
			style={wrapperStyle}
			{...rest}
		/>
	)
}

export default React.memo(Icon)
